/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NavigationEnd, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class RoleGroupApiService {
  private history = [];
  public img = '';
  previousUrl;
  private APIService = environment.serviceUrl;

  constructor(
    private http: HttpClient,
    public snackBar: MatSnackBar,
    private router: Router
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.history.push(event.urlAfterRedirects);
      }
    });
  }

  addRoleGroup(Payload): Observable<any> {
    return this.http.post(this.APIService + 'roleGroup/saveRoleGroup', Payload);
  }

  updateRoleGroup(payload): Observable<any> {
    return this.http.post(this.APIService + 'roleGroup/saveRoleGroup', payload);
  }

  getAllRoleGroup(currentPage, pageSize, search): Observable<any> {
    return this.http.get(
      this.APIService +
        'roleGroup/getRolesGroup?page=' +
        currentPage +
        '&size=' +
        pageSize +
        '&search=' +
        search
    );
  }

  getSingleGroup(id): Observable<any> {
    return this.http.get(
      this.APIService + 'roleGroup/getRoleGroupDetails?id=' + id
    );
  }

  deleteRoleGroup(groupId): Observable<any> {
    return this.http.delete(
      `${this.APIService}roleGroup/deleteRoleGroup?id=${groupId}`
    );
  }
}
